var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 27.5,
    r: 13.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.575 22.1H36.225C35.8522 22.1 35.55 21.7978 35.55 21.425C35.55 21.0517 35.2483 20.75 34.875 20.75H28.125C27.7517 20.75 27.45 21.0517 27.45 21.425C27.45 21.7978 27.1478 22.1 26.775 22.1H25.425C25.0517 22.1 24.75 22.4017 24.75 22.775V24.8C24.75 26.9961 25.442 28.5345 26.658 29.1863C27.4265 29.5983 28.2334 30.0384 28.9011 30.5992C29.2807 30.918 29.7196 31.1683 30.199 31.3312C30.5522 31.4513 30.825 31.7624 30.825 32.1356V32.225C30.825 32.5978 30.5228 32.9 30.15 32.9C29.7772 32.9 29.475 33.2022 29.475 33.575C29.475 33.9478 29.7772 34.25 30.15 34.25H32.85C33.2228 34.25 33.525 33.9478 33.525 33.575C33.525 33.2022 33.2228 32.9 32.85 32.9C32.4772 32.9 32.175 32.5978 32.175 32.225V32.1353C32.175 31.7623 32.4476 31.4511 32.8007 31.3309C33.2799 31.1679 33.7188 30.9176 34.0984 30.599C34.7664 30.0383 35.5735 29.5983 36.3421 29.1863C37.5581 28.5344 38.25 26.996 38.25 24.8V22.775C38.25 22.4017 37.9483 22.1 37.575 22.1ZM26.1 24.8V24.125C26.1 23.7522 26.4022 23.45 26.775 23.45C27.1478 23.45 27.45 23.7522 27.45 24.125V27.5142C27.45 27.7734 27.1845 27.9404 26.9943 27.7642C26.207 27.0349 26.1 25.551 26.1 24.8ZM36.0057 27.7642C35.8155 27.9404 35.55 27.7734 35.55 27.5142V24.125C35.55 23.7522 35.8522 23.45 36.225 23.45C36.5978 23.45 36.9 23.7522 36.9 24.125V24.8C36.9 25.551 36.793 27.0349 36.0057 27.7642Z",
    fill: "#FFA800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 63,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrize);
export default __webpack_public_path__ + "static/media/prize.6d2f80aff242f2c164d1a607a3373107.svg";
export { ForwardRef as ReactComponent };